/**
 * SS media utilities — shared by the SS content sections.
 * window.SsMedia.observeVideos(root): lazy-loads `video[data-ss-lazy-video]`
 * (moves source[data-src] → src when near the viewport), autoplays muted
 * videos while visible, pauses them when hidden, honours
 * prefers-reduced-motion (shows the play button instead of autoplay) and the
 * page visibility state. Idempotent: safe to call for the same root twice.
 */
(function () {
  'use strict';
  if (window.SsMedia) return;

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function load(video) {
    if (video.dataset.ssLoaded === 'true') return;
    video.querySelectorAll('source[data-src]').forEach(function (source) {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
    });
    video.dataset.ssLoaded = 'true';
    try { video.load(); } catch (e) { /* noop */ }
  }

  function tryPlay(video) {
    if (document.hidden) return;
    var promise = video.play();
    if (promise && typeof promise.catch === 'function') promise.catch(function () { showPlayButton(video, true); });
  }

  function showPlayButton(video, show) {
    var button = video.parentElement && video.parentElement.querySelector('[data-ss-video-play]');
    if (button) button.hidden = !show;
  }

  function bindPlayButton(video) {
    var button = video.parentElement && video.parentElement.querySelector('[data-ss-video-play]');
    if (!button || button.dataset.ssBound) return;
    button.dataset.ssBound = 'true';
    button.addEventListener('click', function () {
      load(video);
      video.muted = false;
      video.setAttribute('controls', '');
      tryPlay(video);
      button.hidden = true;
    });
  }

  function observeVideos(root) {
    var scope = root || document;
    var videos = Array.prototype.slice.call(scope.querySelectorAll('video[data-ss-lazy-video]:not([data-ss-observed])'));
    if (!videos.length) return;
    videos.forEach(function (video) {
      video.dataset.ssObserved = 'true';
      bindPlayButton(video);
      if (reduced || video.dataset.ssAutoplay !== 'true') showPlayButton(video, true);
    });
    if (!('IntersectionObserver' in window)) {
      videos.forEach(function (video) { load(video); if (!reduced && video.dataset.ssAutoplay === 'true') tryPlay(video); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        if (entry.isIntersecting) {
          load(video);
          if (!reduced && video.dataset.ssAutoplay === 'true' && !video.hasAttribute('controls')) tryPlay(video);
        } else if (!video.paused) {
          video.pause();
        }
      });
    }, { rootMargin: '200px 0px', threshold: 0.15 });
    videos.forEach(function (video) { observer.observe(video); });
  }

  document.addEventListener('visibilitychange', function () {
    document.querySelectorAll('video[data-ss-lazy-video][data-ss-loaded="true"]').forEach(function (video) {
      if (document.hidden) { if (!video.paused) video.pause(); }
      else if (!reduced && video.dataset.ssAutoplay === 'true' && !video.hasAttribute('controls')) {
        var rect = video.getBoundingClientRect();
        if (rect.bottom > 0 && rect.top < window.innerHeight) tryPlay(video);
      }
    });
  });

  window.SsMedia = { observeVideos: observeVideos, loadVideo: load };
  document.addEventListener('DOMContentLoaded', function () { observeVideos(document); });
  if (document.readyState !== 'loading') observeVideos(document);
  document.addEventListener('shopify:section:load', function (event) { observeVideos(event.target); });
})();
